import React, { ReactNode } from 'react'
import { DecoratorNode, DOMExportOutput, LexicalNode, NodeKey, SerializedLexicalNode } from 'lexical'
import { EmbedType, ParticipantsElement } from '../../../models'
import { EmbeddedParticipants } from '../Embeds/EmbeddedParticipants'

export interface SerializedEmbeddedParticipantsNode extends SerializedLexicalNode {
  element: ParticipantsElement
}

export class EmbeddedParticipantsNode extends DecoratorNode<ReactNode> {
  __element: ParticipantsElement

  static getType(): string {
    return EmbedType.PARTICIPANTS
  }

  static clone(node: EmbeddedParticipantsNode): EmbeddedParticipantsNode {
    return new EmbeddedParticipantsNode(node.__element, node.__key)
  }

  constructor(element: ParticipantsElement, key?: NodeKey) {
    super(key)
    this.__element = element
  }

  createDOM(): HTMLElement {
    return document.createElement('div')
  }

  updateDOM(): false {
    return false
  }

  decorate(): ReactNode {
    return <EmbeddedParticipants element={this.__element} />
  }

  exportJSON(): SerializedEmbeddedParticipantsNode {
    return {
      type: EmbedType.PARTICIPANTS,
      version: 1,
      element: this.__element,
    }
  }

  static importJSON(_serializedNode: SerializedEmbeddedParticipantsNode): EmbeddedParticipantsNode {
    return $createEmbeddedParticipantsNode(_serializedNode.element)
  }

  exportDOM(): DOMExportOutput {
    return {
      element: document.createTextNode(`@embed(participants(${JSON.stringify({ displayId: this.__element.displayId })}))`),
    }
  }
}

export const $createEmbeddedParticipantsNode = (element: ParticipantsElement): EmbeddedParticipantsNode => new EmbeddedParticipantsNode(element)

export const $isEmbeddedParticipantsNode = (node: LexicalNode | null | undefined): node is EmbeddedParticipantsNode => node instanceof EmbeddedParticipantsNode
